import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllUsers } from '../../../actions/user.action';
import { Oval } from 'react-loader-spinner';
import style from './Users.module.css';
import { useNavigate } from 'react-router-dom';

const Users = () => {
  const dispatch = useDispatch();
  const allUser = useSelector((state) => state.getAllUsersReducer);
  const { loading, success, users } = allUser;
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getAllUsers());
  }, [dispatch]);

  const handleUser = (id) => {
    navigate(`/admin/user/${id}`);
  };

  return (
    <>
      <h1 style={{ color: 'rgb(206, 144, 206)' }}>Users</h1>
      <div className={style.Users}>
        {loading ? (
          <div className={style.Center}>
            <Oval
              ariaLabel='loading-indicator'
              height={80}
              width={80}
              strokeWidth={5}
              color='white'
              secondaryColor='purple'
            />
          </div>
        ) : users?.users && users.users.length !== 0 ? (
          <div>
            <div className={style.TableHead}>
              <div>Name</div>
              <div>Email</div>
              <div>Admin</div>
              <div>Verified</div>
              <div>Org</div>
              <div>KYC</div>
            </div>
            <div>
              {users.users
                .slice(0)
                .reverse()
                .map((user) => {
                  return (
                    <div
                      className={`${style.TableData} ${style.UserClick}`}
                      key={user._id}
                      onClick={() => handleUser(user._id)}
                    >
                      <div>{user.name}</div>
                      <div>{user.email}</div>
                      <div>{user.isAdmin ? 'Yes' : 'No'}</div>
                      <div>{user.isVerified ? 'Yes' : 'No'}</div>
                      <div>{user.isOrg ? 'Yes' : 'No'}</div>
                      <div>{user.kycStatus}</div>
                    </div>
                  );
                })}
            </div>
          </div>
        ) : (
          <div className={style.Center} style={{ fontWeight: '500' }}>
            No user found!
          </div>
        )}
      </div>
    </>
  );
};

export default Users;
